import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TimeZone } from '../types/users.types';

@Injectable()
export class LayoutService {
  protected layoutSizeSubject = new BehaviorSubject(false);
  protected overlaySubject = new BehaviorSubject(false);
  protected newReportSubject = new BehaviorSubject(false);
  protected timeZoneSubject = new BehaviorSubject(null);
  protected regressionInProgressSubject = new BehaviorSubject(false);

  getLayoutSizeSubject() {
    return this.layoutSizeSubject;
  }

  setLayoutSizeSubject(value: boolean) {
    return this.layoutSizeSubject.next(value);
  }

  getOverlaySubject() {
    return this.overlaySubject;
  }

  setOverlaySubject(value: boolean) {
    return this.overlaySubject.next(value);
  }

  getNewReportSubject() {
    return this.newReportSubject;
  }

  setNewReportSubject(value: boolean) {
    return this.newReportSubject.next(value);
  }

  getTimeZoneSubject() {
    return this.timeZoneSubject;
  }

  setTimeZoneSubject(value: TimeZone) {
    return this.timeZoneSubject.next(value);
  }

  getRegressionInProgressSubject() {
    return this.regressionInProgressSubject;
  }

  setRegressionInProgressSubject(value: boolean) {
    return this.regressionInProgressSubject.next(value);
  }
  
}
